/**
 * Copyright IBM Corp. 2021
 *
 * This source code is licensed under the IBM Public License Version 1.0 found in the
 * LICENSE file in the root directory of this source tree.
 */

import "./lang/ar";
import "./lang/bg_BG";
import "./lang/ca";
import "./lang/cs";
import "./lang/cy";
import "./lang/da";
import "./lang/de";
import "./lang/el";
import "./lang/eo";
import "./lang/es";
import "./lang/es_ES";
import "./lang/es_MX";
import "./lang/eu";
import "./lang/fa";
import "./lang/fa_IR";
import "./lang/fi";
import "./lang/fr_FR";
import "./lang/gl";
import "./lang/he_IL";
import "./lang/hr";
import "./lang/hu_HU";
import "./lang/hy";
import "./lang/id";
import "./lang/it";
import "./lang/it_IT";
import "./lang/ja";
import "./lang/kk";
import "./lang/ko_KR";
import "./lang/lt";
import "./lang/nb_NO";
import "./lang/nl";
import "./lang/pl";
import "./lang/pt_BR";
import "./lang/pt_PT";
import "./lang/ro";
import "./lang/ro_RO";
import "./lang/ru";
import "./lang/sk";
import "./lang/sl";
import "./lang/sl_SI";
import "./lang/sv_SE";
import "./lang/ta";
import "./lang/ta_IN";
import "./lang/th_TH";
import "./lang/tr";
import "./lang/tr_TR";
import "./lang/uk";
import "./lang/vi";
import "./lang/zh_CN";
import "./lang/zh_TW";

const tririgaLanguageMap = new Map();
tririgaLanguageMap.set("Arabic", "ar");
tririgaLanguageMap.set("Brazilian Portuguese", "pt_BR");
tririgaLanguageMap.set("British English", "");
tririgaLanguageMap.set("Czech", "cs");
tririgaLanguageMap.set("Danish", "da");
tririgaLanguageMap.set("Dutch", "nl");
tririgaLanguageMap.set("Finnish", "fi");
tririgaLanguageMap.set("French", "fr_FR");
tririgaLanguageMap.set("German", "de");
tririgaLanguageMap.set("Hebrew", "he_IL");
tririgaLanguageMap.set("Hungarian", "hu_HU");
tririgaLanguageMap.set("Italian", "it");
tririgaLanguageMap.set("Japanese", "ja");
tririgaLanguageMap.set("Korean", "ko_KR");
tririgaLanguageMap.set("Norwegian", "nb_NO");
tririgaLanguageMap.set("Polish", "pl");
tririgaLanguageMap.set("Russian", "ru");
tririgaLanguageMap.set("Simplified Chinese", "zh_CN");
tririgaLanguageMap.set("Spanish", "es");
tririgaLanguageMap.set("Swedish", "sv_SE");
tririgaLanguageMap.set("Traditional Chinese", "zh_TW");
tririgaLanguageMap.set("US English", "");

export function getEditorLanguage(tririgaLanguage) {
  const editorLanguage = tririgaLanguageMap.get(tririgaLanguage);
  return editorLanguage === undefined ? tririgaLanguage : editorLanguage;
}
